<template>
    <div class="onboarding-screen">
        <div class="onboarding-screen__button" @click="openPanel">
            <CompassIcon
                icon="custom-checks"
                size="large"
                class="onboarding-screen__button--icon"
            />
            <span class="onboarding-screen__button--label typographies-paragraph-small-bold">
                {{ $l10n.__('Commencer avec Sellsy') }}
            </span>
        </div>
    </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const popupPanelMapActions = createNamespacedHelpers('popupPanel').mapActions;

export default {
    methods: {
        ...popupPanelMapActions(['open']),

        openPanel() {
            this.open({
                key: 'onboardingScreenPanel',
                props: {},
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.onboarding-screen {
    display: flex;
    align-items: center;
    margin: 0 var(--spacing-3) 0 0;

    &__button {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        width: 117px;
        padding: 0 var(--spacing-1);
        gap: var(--spacing-1);
        border-radius: var(--spacing-1);
        background-color: var(--colors-common-background-subtle);
        cursor: pointer;

        &:hover {
            background-color: var(--colors-common-background-primary-subtle);
        }

        &--icon {
            flex-shrink: 0;
        }

        &--label {
            color: var(--colors-common-text-brand-secondary-blue);
        }
    }
}

@media screen and (width < 960px) {
    .onboarding-screen {
        &__button {
            width: auto;

            &--label {
                display: none;
            }
        }
    }
}
</style>
